import React, { createContext, useState } from "react";

export const AvailableCollectionsContext = createContext();

export const AvailableCollectionsProvider = ({ children }) => {
  const [availableCollections, setAvailableCollections] = useState([]);

  const updateAvailableCollections = (collections) => {
    setAvailableCollections(collections);
  };

  return (
    <AvailableCollectionsContext.Provider
      value={{ availableCollections, updateAvailableCollections }}
    >
      {children}
    </AvailableCollectionsContext.Provider>
  );
};
